<template>
  <VerificationForm />
</template>
<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useTitle } from "@vueuse/core";
import VerificationForm from "@/components/forms/VerificationForm.vue";
import { useGlobalStore } from "@/stores/globalStore";

const globalStore = useGlobalStore();
const router = useRouter();

onMounted(() => {
  const msisdnRequired =
    globalStore.getMerchantSettings?.msisdnRequired === true;
  if (!msisdnRequired) {
    router.push("/verification/code");
  }
});

useTitle("Banxa - Verify your email");
</script>
